import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { CityFilterRequest } from "@/main/models/request";
import { Result } from "@/main/models/common/resultResponse";

export abstract class ICityApi {
	abstract getDomain(request: CityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDomainPublic(request: CityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
